import { render } from "./EsqueciMinhaSenhaGex.vue?vue&type=template&id=2409a6c8&scoped=true"
import script from "./EsqueciMinhaSenhaGex.vue?vue&type=script&lang=js"
export * from "./EsqueciMinhaSenhaGex.vue?vue&type=script&lang=js"

import "./EsqueciMinhaSenhaGex.vue?vue&type=style&index=0&id=2409a6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2409a6c8"]])

export default __exports__